module.exports = __webpack_public_path__ + "img/img-13.ce3d527b.png";